/**
 * Documenti utili mostrati in fondo a tutte le pagine (pubbliche e dashboard), salvo i percorsi
 * di PERCORSI_ESCLUSI. SEZIONI_DOCUMENTI permette set specifici per path; senza voce si usa SET_BASE.
 * I documenti devono essere ad accesso libero (`AccessoLibero` sul file o sulla cartella principale)
 * per essere scaricabili da tutti; altrimenti il download dipende dai permessi del ruolo.
 * Per aggiungere/togliere documenti o sezioni modificare SOLO questo file.
 */

// Catalogo: chiave logica → { id t_files, etichetta }
export const DOCUMENTI = {
  guidaRegistrazione:   { id: 9074, label: 'Guida: come registrarsi alla Sezione Formazione' },
  guidaVideoseminari:   { id: 9075, label: 'Guida: prenotazione videoseminari' },
  guidaPresenza:        { id: 9076, label: 'Guida: prenotazione iniziative in presenza' },
  detAccertatori:       { id: 9070, label: 'Determina autorizzazione corso Accertatori' },
  detAccertatoriCup:    { id: 9071, label: 'Determina autorizzazione corso Accertatori (valido CUP)' },
  detMessi:             { id: 9072, label: 'Determina autorizzazione corso Messi notificatori' },
  detRiscossione:       { id: 9073, label: 'Determina autorizzazione corso Funzionario Responsabile Riscossione' },
  delegaReferente:      { id: 249, label: 'Delega per referente ANUTEL ETS' },
  iscrizioneMepa:       { id: 9039, label: 'Iscrizione MEPA' },
  delegaAssemblee:      { id: 7702, label: 'Delega per Assemblee' },
  guidaDocenti:         { id: 9187, label: 'Guida operativa per i Docenti' },
};

// Set iniziale: per ora identico per tutte le sezioni
const SET_BASE = [
  'guidaRegistrazione', 'guidaVideoseminari', 'guidaPresenza',
  'detAccertatori', 'detAccertatoriCup', 'detMessi', 'detRiscossione',
  'delegaReferente', 'iscrizioneMepa', 'delegaAssemblee',
];

// Pagine Docenze: come SET_BASE, con la Guida operativa per i Docenti in testa
const SET_DOCENZE = ['guidaDocenti', ...SET_BASE];

// Path (senza slash finale) → elenco chiavi del catalogo
export const SEZIONI_DOCUMENTI = {
  '/':                                           SET_BASE,
  '/dashboard':                                  SET_BASE,
  '/dashboard/profilo':                          SET_BASE,
  '/dashboard/referente/collaboratori':          SET_BASE,
  '/dashboard/referente/stato':                  SET_BASE,
  '/dashboard/referente/newsletter':             SET_BASE,
  '/dashboard/referente/assistenza-giuridica':   SET_BASE,
  '/dashboard/formazione/diretta':               SET_BASE,
  '/dashboard/formazione/differita':             SET_BASE,
  '/dashboard/formazione/abilitativi':           SET_BASE,
  '/dashboard/formazione/progressi':             SET_BASE,
  '/dashboard/formazione/galleria':              SET_BASE,
  '/dashboard/docenze/programmi':                SET_DOCENZE,
  '/dashboard/docenze/iniziative':               SET_DOCENZE,
  // Associato
  '/dashboard/associato/ricerche':               SET_BASE,
  '/dashboard/associato/pubblicazioni':          SET_BASE,
  '/dashboard/associato/regolamento':            SET_BASE,
  // Referente
  '/dashboard/referente/regolamento':            SET_BASE,
  // Accesso riservato
  '/dashboard/accesso-riservato/ricerche':       SET_BASE,
  '/dashboard/accesso-riservato/pubblicazioni':  SET_BASE,
  '/dashboard/accesso-riservato/archivio-videocorsi': SET_BASE,
  '/dashboard/accesso-riservato/regolamento':    SET_BASE,
  // Associato personale
  '/dashboard/personale/stato':                  SET_BASE,
  // Formazione e docenze (regolamento)
  '/dashboard/formazione/regolamento':           SET_BASE,
  '/dashboard/docenze/regolamento':              SET_DOCENZE,
  // Comitati
  '/dashboard/comitato/temi':                    SET_BASE,
  '/dashboard/comitato/regionali':               SET_BASE,
  '/dashboard/comitato/associati':               SET_BASE,
  '/dashboard/comitato/partecipazioni':          SET_BASE,
  '/dashboard/comitato/regolamento':             SET_BASE,
  // Amministrazione
  '/dashboard/amministrazione/associati':        SET_BASE,
  '/dashboard/amministrazione/iniziative':       SET_BASE,
  '/dashboard/amministrazione/temi':             SET_BASE,
  '/dashboard/amministrazione/presenze_organi':  SET_BASE,
  '/dashboard/amministrazione/regolamento':      SET_BASE,
  '/iniziative': SET_BASE,
};

// Percorsi (prefissi, senza basename) senza box: flussi obbligati in cui sarebbe fuori contesto
export const PERCORSI_ESCLUSI = [
  '/recupero-password',
  '/completamento-profilo',
  '/presa-visione-informativa',
];

// Restituisce l'elenco { id, label } per il path dato: [] per i percorsi esclusi,
// altrimenti il set specifico del path o, se assente, SET_BASE
export function getDocumentiSezione(pathname) {
  const path = (pathname || '').replace(/\/+$/, '').toLowerCase();
  if (PERCORSI_ESCLUSI.some((p) => path === p || path.startsWith(`${p}/`))) return [];
  const chiavi = SEZIONI_DOCUMENTI[path] || SET_BASE;
  return chiavi.map((k) => DOCUMENTI[k]).filter(Boolean);
}
